import {
  HWSLandingPageRedirectionBrands,
  hotelsSublink,
  reviewsSubLink,
  reviewsRedirectionVarValue,
  trcRedirectionVarValue,
  trcRedirectionURL,
  chinaLocale,
  overviewSubLink,
  hardCodedAllLocale,
  HWSRedirectionVarValue,
  TC_Locale,
} from '../constants/lib/constants';
import { addSubDirectoryPrefix } from './subDirectoryFunctions';
import { NAVIGATION_URL_CONSTANTS } from '../organisms/OSearchResults/config';

/**
 * Pure version of {@link useRedirectionRules} for use outside React (e.g. property card view models).
 * Mirrors shop HQV / PropertyCard redirection behavior.
 */
export function computeRedirectionUrl(
  brandCode?: string,
  marshaCode?: string,
  propertyName?: string,
  redirectionType?: string,
  localeArg?: string,
  seoNickName?: string | null,
  location?: string | null,
  redirectionDomain?: string | null
): string {
  let redirectionURL = '';
  let locale = localeArg;
  const formedURL =
    marshaCode?.toLowerCase() +
    '-' +
    propertyName
      ?.replace('-', ' ')
      ?.replace(/([~!@#$%^&*()_+=`{}[\]|\\:;'<>,./? ])+/g, '-')
      ?.replace(/^(-)+|(-)+$/g, '')
      ?.toLowerCase();
  if (redirectionType === reviewsRedirectionVarValue) {
    if (brandCode && HWSLandingPageRedirectionBrands.includes(brandCode)) {
      const locale = localeArg?.toLowerCase();
      const URLlocale =
        locale?.toLowerCase() === TC_Locale
          ? 'zh-hk'
          : locale?.toLowerCase() === chinaLocale
          ? locale
          : locale?.split('-')[0];
      redirectionURL = trcRedirectionURL + URLlocale + hotelsSublink + (seoNickName ?? formedURL) + overviewSubLink;
    } else {
      if (locale === hardCodedAllLocale?.en) {
        redirectionURL = '/' + locale + hotelsSublink + (seoNickName ?? formedURL) + reviewsSubLink;
      } else {
        redirectionURL =
          addSubDirectoryPrefix(NAVIGATION_URL_CONSTANTS.SM_VIEW_HOTEL_WEBSITE_LINK) + (seoNickName ?? formedURL);
      }
    }
  } else if (redirectionType === trcRedirectionVarValue) {
    locale = locale?.toLowerCase();
    const URLlocale =
      locale?.toLowerCase() === TC_Locale
        ? 'zh-hk'
        : locale?.toLowerCase() === chinaLocale
        ? locale
        : locale?.split('-')[0];
    redirectionURL = trcRedirectionURL + URLlocale + hotelsSublink + (seoNickName ?? formedURL) + overviewSubLink;
  } else if (redirectionType === HWSRedirectionVarValue) {
    if (brandCode === 'BG') {
      locale = locale?.toLowerCase();
      const URLlocale =
        locale?.toLowerCase() === chinaLocale
          ? locale
          : locale?.split('-')?.[0] + '_' + locale?.split('-')?.[1]?.toUpperCase();
      redirectionURL = (redirectionDomain ?? '') + '/' + URLlocale + '/' + location?.toLowerCase()?.replace(' ', '-');
    }
  }
  return redirectionURL;
}
